/**
 * BCo back-in-stock (10-8-26)
 * Works alongside product-information-v1.js (listens for its piv1:variant event) and the
 * restock app button (.restock-alerts-notify-button) the app injects into the product form.
 */
(function () {
  'use strict';

  var NOTIFY_SELECTOR = '.restock-alerts-notify-button';
  // The app's label for sold-out sizes ("Out of stock? Click here") isn't editable in its settings screen.
  var NOTIFY_LABEL = 'Notify me when available';
  // The app's "news and offers" checkbox (.agreementCheckboxStyle) comes pre-checked; start it unchecked.
  var CONSENT_SELECTOR = '.restock-alerts-form input[type="checkbox"], .agreementCheckboxStyle';

  function relabel(btn) {
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
    var first = true;
    var n;
    while ((n = walker.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      if (first) {
        if (n.nodeValue.trim() !== NOTIFY_LABEL) n.nodeValue = NOTIFY_LABEL;
        first = false;
      } else {
        n.nodeValue = '';
      }
    }
  }

  function uncheckConsent() {
    document.querySelectorAll(CONSENT_SELECTOR).forEach(function (cb) {
      if (cb.dataset.bcoDefaulted === '1') return;
      cb.dataset.bcoDefaulted = '1';
      // A real click keeps the app's own form state in sync.
      if (cb.checked) cb.click();
    });
  }

  function formatMoney(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, fmt);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, fmt);
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  // Adds the product row, intro line and footnote from the BCo mockup to the app's pop-up.
  // Checked on every DOM change, so if the app redraws its form they are added back.
  function enhanceModal() {
    var box = document.querySelector('.restock-alerts-modal-box');
    var form = box && box.querySelector('.restock-alerts-form');
    var root = document.querySelector('[data-piv1]');
    if (!form || !root) return;

    var variants = parseJSON((root.querySelector('[data-piv1-variants-json]') || {}).textContent, []);
    var appSelect = form.querySelector('.restock-alerts-variant-select');
    var pdpSelect = root.querySelector('[data-piv1-variant-select]');
    var id = (appSelect && appSelect.value) || (pdpSelect && pdpSelect.value);
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) { v = variants[i]; break; }
    }

    if (!form.querySelector('.bco-bis-product')) {
      var h1 = root.querySelector('h1');
      var row = el('div', 'bco-bis-product');
      var src = (v && v.featured_image && v.featured_image.src) || '';
      if (!src) {
        var gImg = root.querySelector('[data-piv1-gallery] img');
        src = gImg ? (gImg.currentSrc || gImg.src) : '';
      }
      if (src) {
        var img = el('img', 'bco-bis-product__img');
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        img.alt = '';
        row.appendChild(img);
      }
      var info = el('div', 'bco-bis-product__info');
      info.appendChild(el('div', 'bco-bis-product__name', h1 ? h1.textContent.trim() : ''));
      if (v) {
        var meta = (v.title && v.title !== 'Default Title' ? v.title + ' · ' : '') + formatMoney(v.price);
        info.appendChild(el('div', 'bco-bis-product__meta', meta));
      }
      row.appendChild(info);
      form.insertBefore(row, form.firstChild);
    }

    var title = form.querySelector('.restock-alerts-form-title');
    if (title && !form.querySelector('.bco-bis-sub')) {
      var statusTitle = root.querySelector('[data-bco-stock-title]');
      var lead = statusTitle && statusTitle.textContent.trim() ? statusTitle.textContent.trim() : 'This item is sold out';
      var sub = el('p', 'bco-bis-sub', lead + " right now. Leave your email and we'll let you know as soon as it's restocked.");
      title.parentNode.insertBefore(sub, title.nextSibling);
    }

    var lower = box.querySelector('.modalBoxLowerSectionStyle');
    if (lower && !lower.querySelector('.bco-bis-foot')) {
      var foot = el('p', 'bco-bis-foot', "We'll email you when this item is back. No spam. ");
      var link = el('a', '', 'Privacy Policy');
      link.href = '/policies/privacy-policy';
      link.target = '_blank';
      link.rel = 'noopener';
      foot.appendChild(link);
      lower.appendChild(foot);
    }
  }

  function watchModal() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        uncheckConsent();
        enhanceModal();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function joinList(items) {
    if (items.length <= 1) return items.join('');
    return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
  }

  function parseJSON(text, fallback) {
    try { return JSON.parse(text || ''); } catch (e) { return fallback; }
  }

  function setup(root) {
    if (!root || root.dataset.bcoBis === '1') return;
    var status = root.querySelector('[data-bco-stock-status]');
    if (!status) return;
    root.dataset.bcoBis = '1';

    var form = root.querySelector('[data-piv1-form]');
    var atc = root.querySelector('[data-piv1-atc]');
    // Place the status line directly above the Add to Cart / notify buttons.
    if (atc && atc.parentNode && status.nextElementSibling !== atc) {
      atc.parentNode.insertBefore(status, atc);
    }
    var select = root.querySelector('[data-piv1-variant-select]');
    var titleEl = status.querySelector('[data-bco-stock-title]');
    var subEl = status.querySelector('[data-bco-stock-sub]');
    var alt = root.querySelector('[data-bco-stock-alt]');
    var altLabel = alt && alt.querySelector('[data-bco-alt-label]');
    var altLinks = alt && alt.querySelector('[data-bco-alt-links]');
    var ship = root.querySelector('.piv1__ship');
    var shipText = ship && ship.querySelector('span:last-child');
    var shipOriginal = shipText ? shipText.textContent.trim() : '';

    var variants = parseJSON((root.querySelector('[data-piv1-variants-json]') || {}).textContent, []);
    var optionNames = parseJSON(status.getAttribute('data-bco-options'), []);
    var sizeIdx = -1;
    var colorIdx = -1;
    optionNames.forEach(function (name, i) {
      var n = String(name).toLowerCase();
      if (sizeIdx < 0 && n.indexOf('size') > -1) sizeIdx = i;
      if (colorIdx < 0 && (n.indexOf('color') > -1 || n.indexOf('colour') > -1)) colorIdx = i;
    });

    function opt(v, i) {
      return (v.options && v.options[i]) || v['option' + (i + 1)];
    }

    function syncNotify() {
      var btn = form && form.querySelector(NOTIFY_SELECTOR);
      var present = !!btn;
      if (btn) relabel(btn);
      if (form) form.classList.toggle('bco-notify-ready', present);
      if (subEl) subEl.hidden = !present;
    }

    function selectColor(color) {
      var group = root.querySelector('[data-piv1-option][data-option-index="' + colorIdx + '"]');
      if (!group) return;
      var inputs = group.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === color) {
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }

    function render(v) {
      if (!v) return;
      var soldOut = !v.available;
      status.hidden = !soldOut;

      var size = sizeIdx > -1 ? opt(v, sizeIdx) : '';
      var color = colorIdx > -1 ? opt(v, colorIdx) : '';

      if (soldOut && titleEl) {
        if (size && color) titleEl.textContent = size + ' is sold out in ' + color;
        else if (size) titleEl.textContent = size + ' is sold out';
        else if (v.title && v.title !== 'Default Title') titleEl.textContent = v.title + ' is sold out';
        else titleEl.textContent = 'This item is sold out';
      }

      // Shipping line: name the sizes that do ship, instead of promising 1-day shipping on a sold-out size.
      if (ship && shipText) {
        if (!soldOut) {
          shipText.textContent = shipOriginal;
          ship.hidden = false;
        } else {
          var inStock = [];
          if (sizeIdx > -1) {
            variants.forEach(function (o) {
              if (!o.available) return;
              if (colorIdx > -1 && opt(o, colorIdx) !== color) return;
              var s = opt(o, sizeIdx);
              if (inStock.indexOf(s) === -1) inStock.push(s);
            });
          }
          var m = shipOriginal.match(/^usually ships\s+(.+)$/i);
          if (inStock.length && m) {
            shipText.textContent = joinList(inStock) + (inStock.length > 1 ? ' usually ship ' : ' usually ships ') + m[1];
            ship.hidden = false;
          } else {
            ship.hidden = true;
          }
        }
      }

      // "Need it now?" — other colors that have this size in stock.
      if (alt && altLinks) {
        var others = [];
        if (soldOut && size && colorIdx > -1) {
          variants.forEach(function (o) {
            if (!o.available || opt(o, sizeIdx) !== size) return;
            var c = opt(o, colorIdx);
            if (c !== color && others.indexOf(c) === -1) others.push(c);
          });
        }
        altLinks.innerHTML = '';
        others.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bco-stock-alt__btn';
          b.textContent = c;
          b.setAttribute('aria-label', 'Switch to ' + c + ', ' + size + ' in stock');
          b.addEventListener('click', function () { selectColor(c); });
          altLinks.appendChild(b);
        });
        if (altLabel) altLabel.textContent = size + ' is in stock in';
        alt.hidden = others.length === 0;
      }

      syncNotify();
    }

    function currentVariant() {
      var id = select && select.value;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    root.addEventListener('piv1:variant', function (ev) {
      render(ev.detail || currentVariant());
    });

    if (form && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncNotify).observe(form, { childList: true, subtree: true });
    }

    render(currentVariant());
  }

  function boot() {
    document.querySelectorAll('[data-piv1]').forEach(setup);
    watchModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-piv1]');
    if (root) {
      delete root.dataset.bcoBis;
      setup(root);
    }
  });
})();
